import { AgentDirectoryTable } from '../../components/agents/AgentDirectoryTable.tsx'
import { PageHeader } from '../../components/layout/PageHeader.tsx'

/**
 * Agentes da empresa (`GET /api/tenant/agents`, §5.3), com o estado de cada um.
 * Somente leitura: revogar, suspender e reativar são da Black Ghost.
 */
export function TenantAgents() {
  return (
    <>
      <PageHeader title="Agentes" />
      <AgentDirectoryTable />
    </>
  )
}
